import React, {FunctionComponent} from 'react';
import {TGalleryCarouselIndicatorProps} from '../types/gallerycarousel.types';

const GalleryCarouselIndicator: FunctionComponent<TGalleryCarouselIndicatorProps> = ({
                                                                                       isSelected = false,
                                                                                       index,
                                                                                       baseClassName = 'controls__dots__item',
                                                                                       goSelected,
                                                                                     }) => {
  const className = isSelected ? baseClassName + ' ' + baseClassName + '--selected' : baseClassName;

  return <li className={className} value={index} onClick={() => goSelected(index)}/>;
};

export default GalleryCarouselIndicator;
